import { render, staticRenderFns } from "./ElectronicSetting.vue?vue&type=template&id=282b2612&"
import script from "./ElectronicSetting.vue?vue&type=script&lang=js&"
export * from "./ElectronicSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports